"use strict";

angular.module('PatientApp').service('ContextHelperService', function (VuexStore) {
  this.showBreadCrumbs = function (specs) {
    return VuexStore.dispatch('showBreadCrumbs', specs);
  };

  this.breadCrumbClick = function () {
    return VuexStore.dispatch('breadCrumbClick');
  };
});